module.exports = __webpack_public_path__ + "static/img/1005_small.f476c5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1005_small.png
// module id = tL2E
// module chunks = 1